import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { PluginKey } from '@atlaskit/editor-prosemirror/state';
export var trackLastRemoteConflictPluginKey = new PluginKey('trackLastRemoteConflict');
export var createPlugin = function createPlugin() {
  return new SafePlugin({
    key: trackLastRemoteConflictPluginKey,
    state: {
      init: function init() {
        return undefined;
      },
      apply: function apply(transaction, prevPluginState) {
        var metadata = transaction.getMeta(trackLastRemoteConflictPluginKey);
        if (metadata) {
          return metadata;
        }
        return prevPluginState;
      }
    }
  });
};